import { useState } from "react";
import { Link } from "react-router-dom";
import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";
import { Logo } from "./Bits";
import { api, errMsg } from "@/lib/api";

const LEGAL = [["Termos de uso", "termos-de-uso"], ["Privacidade (LGPD)", "privacidade"], ["Trocas e devoluções", "trocas-e-devolucoes"], ["Frete", "frete"], ["Cookies", "cookies"]];

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [ok, setOk] = useState(false);
  const [aceite, setAceite] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email, consentimento: aceite });
      setOk(true);
    } catch (er) {
      toast.error(errMsg(er));
    }
  };
  if (ok) return <p className="rounded-3xl bg-white/10 p-5 text-white" data-testid="newsletter-success">Pronto! Use o cupom <b className="text-na-gold">BEMVINDO10</b> na sua primeira compra.</p>;
  return (
    <form onSubmit={send} className="space-y-3" data-testid="newsletter-form">
      <div className="flex flex-col gap-2 sm:flex-row">
        <label htmlFor="news-email" className="sr-only">Seu e-mail</label>
        <input id="news-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Seu melhor e-mail" className="input-na rounded-full" data-testid="newsletter-email" />
        <button className="btn-acai shrink-0" data-testid="newsletter-submit">Quero meu cupom</button>
      </div>
      <label className="flex items-start gap-2 text-xs text-white/80">
        <input type="checkbox" checked={aceite} onChange={(e) => setAceite(e.target.checked)} className="mt-0.5" data-testid="newsletter-consent" />
        Aceito receber e-mails da Nativa Amazon. Posso cancelar quando quiser.
      </label>
    </form>
  );
}

export default function Footer({ minimal }) {
  const { settings } = useStore();
  const e = settings?.empresa || {};
  const copy = () => {
    navigator.clipboard?.writeText(settings?.whatsapp_exibicao || "");
    toast.success("Número copiado");
  };
  return (
    <footer className="mt-24 bg-na-ink text-white/80" data-testid="footer">
      <div className="container-na grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-md text-sm">Produtos naturais regularizados, com laudo por lote e informação completa. Para o seu ritual de autocuidado.</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a href={`https://wa.me/${settings?.whatsapp_e164 || "5531987686700"}`} target="_blank" rel="noreferrer" className="btn-wa" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" /> {settings?.whatsapp_exibicao}</a>
            <button onClick={copy} className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-3 text-sm hover:bg-white/10" data-testid="copy-number-button"><Copy className="h-4 w-4" /> Copiar número</button>
          </div>
        </div>
        {!minimal && (
          <div>
            <p className="eyebrow mb-3">Loja</p>
            <ul className="space-y-2 text-sm">
              {[["Suplementos", "/categoria/suplementos"], ["Fitoterápicos", "/categoria/fitoterapicos"], ["Chás", "/categoria/chas"], ["Kits", "/kits"], ["Minha conta", "/conta"]].map(([l, to]) => <li key={to}><Link to={to} className="hover:text-white">{l}</Link></li>)}
            </ul>
          </div>
        )}
        <div>
          <p className="eyebrow mb-3">Ajuda</p>
          <ul className="space-y-2 text-sm">
            {LEGAL.map(([l, s]) => <li key={s}><Link to={`/paginas/${s}`} className="hover:text-white" data-testid={`legal-${s}`}>{l}</Link></li>)}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-na space-y-2 py-6 text-xs text-white/60" data-testid="footer-company">
          <p>{e.razao_social} · CNPJ {e.cnpj} · {e.endereco} · Licença sanitária {e.licenca_sanitaria} · {e.email} · WhatsApp {settings?.whatsapp_exibicao}</p>
          <p className="font-medium text-white/80">Os produtos não são medicamentos e não substituem orientação médica.</p>
        </div>
      </div>
    </footer>
  );
}
